import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";

import Button from "@material-ui/core/Button";
import Switch from "@material-ui/core/Switch";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { DelayInput } from "react-delay-input";
import InputSelect from "../components/common/InputSelect";
import Schedule from "../components/common/Schedule";
import ScheduleTNT from "../components/common/ScheduleTbl";

import { TextField } from "@material-ui/core";
import KeyboardEventHandler from "react-keyboard-event-handler";
import Loader from "../components/common/loader/Loader";
import { toast } from "react-toastify";
import "./LinesManager.css";

const LinesManager = forwardRef((props, ref) => {
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    root: {
      width: "100%",
      padding: theme.spacing(2),
      boxSizing: "border-box",
      useState,
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: 8,
      },
    },
    switchRoot: {
      width: 34,
      height: 20,
      padding: 0,
      display: "flex",
    },
    switchBase: {
      padding: 2,
      "&$switchChecked": {
        transform: "translateX(14px)",
        color: "#fff",
        "& + $switchTrack": {
          backgroundColor: "#6366f1",
          opacity: 1,
          border: "none",
        },
      },
    },
    switchThumb: {
      width: 16,
      height: 16,
      boxShadow: "none",
    },
    switchTrack: {
      borderRadius: 10,
      border: "1px solid rgba(0,0,0,0.15)",
      backgroundColor: "#e5e7eb",
      opacity: 1,
      transition: "background-color 0.2s, border 0.2s",
    },
    switchChecked: {},
  }));
  const classes = useStyles();

  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const [games, setGames] = useState();
  const [IdSport, setIdSport] = useState("");
  const [SportChange, setSportChange] = useState(true);
  const [lineTypeID, setlineTypeID] = useState(1);
  const [lineTypes, setLineTypes] = useState();
  const [sports, setSports] = useState();
  const [leagues, setLeagues] = useState();
  const [leagueID, setLeagueID] = useState(-1);
  const [open, setOpen] = React.useState(false);
  const [action, setAction] = React.useState(true);
  const [lineTypeAction, setLineTypeAction] = useState(-1);
  const [isLoading, setIsLoading] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [recentUpdatedGame, setRecentUpdatedGame] = useState("");
  const [filterStr, setFilterStr] = useState("");
  const [idGameTNT, setIdGameTNT] = useState(0);
  const [selectedGame, setSelectedGame] = useState([]);
  const [isGrading, setIsGrading] = useState(false);
  const [familyGameFilter, setFamilyGameFilter] = useState(null);

  const familyGameFilterRef = useRef(familyGameFilter);
  const selectedGameRef = useRef(selectedGame);
  const gamesRef = useRef(games);
  useEffect(() => { familyGameFilterRef.current = familyGameFilter; }, [familyGameFilter]);
  useEffect(() => { selectedGameRef.current = selectedGame; }, [selectedGame]);
  useEffect(() => { gamesRef.current = games; }, [games]);

  useEffect(() => {
    const handleCtrlF = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === "f") {
        e.preventDefault();
        e.stopPropagation();
        console.log("[CtrlF] fired. filter:", familyGameFilterRef.current, "selected:", selectedGameRef.current);
        if (familyGameFilterRef.current !== null) {
          setFamilyGameFilter(null);
        } else {
          const lastSelectedId = selectedGameRef.current[selectedGameRef.current.length - 1];
          if (lastSelectedId != null && gamesRef.current) {
            const selected = gamesRef.current.find((g) => g.idGame === lastSelectedId);
            console.log("[CtrlF] found game:", selected?.idGame, "parentGame:", selected?.parentGame);
            if (selected && selected.parentGame) {
              setFamilyGameFilter(selected.parentGame);
            }
          }
        }
      }
    };
    window.addEventListener("keydown", handleCtrlF, true);
    return () => window.removeEventListener("keydown", handleCtrlF, true);
  }, []);

  const setEventKey = function (key, e) {
    switch (key) {
      case "f4":
        changeSportID("NFL");
        break;
      case "f6":
        changeSportID("CFB");
        break;
      case "f7":
        changeSportID("NBA");
        break;
      case "f8":
        changeSportID("CBB");
        break;
      case "f9":
        changeSportID("MLB");
        break;
      case "f10":
        changeSportID("NHL");
        break;
      case "f11":
        changeSportID("MU");
        break;
      case "ctrl+f9":
        changeSportID("SOC");
        break;
      case "ctrl+f10":
        changeSportID("TNT");
        break;
      case "ctrl++":
        // Acción para "ctrl++"
        break;
      case "ctrl+-":
        // Acción para "ctrl+-"
        break;
      case "ctrl+g":
        SendToGrade(e);
        break;
      default:
        // Acción por defecto si ninguna tecla coincide
        break;
    }
  };

  const SendToGrade = (event) => {
    event.preventDefault();
    if (isGrading) return;
    setIsGrading(true);

    axios({
      method: "post",
      url: process.env.REACT_APP_APIGRADE_URL + "/Grade/GradeGamesFromDB?idUser=" + userInfo.userId,
    }).then((response) => {
      const result = response.data;
      if (result.code === 0) {
        toast("Grading done.", { type: "success", autoClose: 3000 });
      } else if (result.code === 2) {
        toast(
          `Grading process cannot be executed. User: ${result.loginName} has been running it since: ${result.beginTime}`,
          { type: "warning", autoClose: 5000 }
        );
      } else {
        toast("An error has occurred.", { type: "error", autoClose: 3000 });
      }
      setIsGrading(false);
      console.log("response", response);
    }).catch((error) => {
      setIsGrading(false);
      toast("An error has occurred.", { type: "error", autoClose: 3000 });
      console.error("Error:", error);
    });
  };


  useImperativeHandle(ref, () => ({
    searchGameValuesChild(gameInfo) {
      var lastSystemChangedLinesId = JSON.parse(
        localStorage.getItem("lastSystemChangedLinesId")
      );
      var scheduleArray = JSON.parse(localStorage.getItem("scheduleArray"));
      const url =
        process.env.REACT_APP_API_URL +
        `/SYSTEMCHANGEDLINES?filter=IdGame,eq,${gameInfo.idGame}&order=IdSystemChangedLines,desc&size=1`;

      axios
        .get(url)
        .then((response) => response.data)
        .then((data) => {
          let systemChangedLine = data.records[0];
          localStorage.setItem(
            "lastSystemChangedLinesId",
            JSON.stringify(systemChangedLine.IdSystemChangedLines)
          );
          if (
            scheduleArray &&
            scheduleArray.some((e) => e.IdGame === systemChangedLine.IdGame) &&
            JSON.stringify(systemChangedLine.IdSystemChangedLines) !=
            lastSystemChangedLinesId
          ) {
            setIsChanged(true);
            searchGameValues(gameInfo.idGame, gameInfo.idLinetype);
            setIsChanged(false);
          }
        });
    },
  }));

  const getGameTypes = useCallback(() => {
    const url = process.env.REACT_APP_API2_URL + "/GameType/GameType_Get";
    return axios.get(url).then((response) => response.data);
  }, []);

  const getGameColors = useCallback(() => {
    const url = process.env.REACT_APP_API2_URL + "/Game/SystemColors_GetList";
    return axios.get(url).then((response) => response.data);
  }, []);

  const searchGameValues = (idGame, idLinetype) => {
    ClearArrar();
    setIsLoading(true);
    setGames([])
    if (
      idGame &&
      idLinetype &&
      // idGame !== recentUpdatedGame &&
      lineTypeID == !idLinetype
    ) {
      axios({
        method: "post",
        url: process.env.REACT_APP_DEF_PHP_URL + "/GamesGameData.php",
        /*  REPLACE WITH SELECT DATA */
        data: {
          idgame: idGame,
          idlinetype: idLinetype,
        },
      })
        .then((response) => response.data)
        .then((data) => {
          let mappedArr = data.data.map((x) => {
            return {
              VisitorOdds: x[38],
              HomeOdds: x[39],
              TotalOver: x[40],
              OverOdds: x[41],
              TotalUnder: x[42],
              UnderOdds: x[43],
              VisitorSpread: x[44],
              VisitorSpreadOdds: x[45],
              HomeSpread: x[46],
              HomeSpreadOdds: x[47],
              VisitorSpecial: x[48],
              VisitorSpecialOdds: x[49],
              HomeSpecial: x[50],
              HomeSpecialOdds: x[51],
              IdGameType: x[5],
              GameStat: x[11],
              Description: x[36],
              ParentGame: x[21],
              GameDateTime: x[7],
              Printable: x[62],
            };

            ////ACA mappedArr = mappedArr.Filter (filtro)
          });

          if (games) {
            let thisGame = games.filter((g) => g.IdGame == idGame)[0];
            if (thisGame) {
              thisGame.VisitorOdds = mappedArr[0].VisitorOdds;
              thisGame.HomeOdds = mappedArr[0].HomeOdds;
              thisGame.TotalOver = mappedArr[0].TotalOver;
              thisGame.OverOdds = mappedArr[0].OverOdds;
              thisGame.TotalUnder = mappedArr[0].TotalUnder;
              thisGame.UnderOdds = mappedArr[0].UnderOdds;
              thisGame.VisitorSpread = mappedArr[0].VisitorSpread;
              thisGame.VisitorSpreadOdds = mappedArr[0].VisitorSpreadOdds;
              thisGame.HomeSpread = mappedArr[0].HomeSpread;
              thisGame.HomeSpreadOdds = mappedArr[0].HomeSpreadOdds;
              thisGame.VisitorSpecial = mappedArr[0].VisitorSpecial;
              thisGame.VisitorSpecialOdds = mappedArr[0].VisitorSpecialOdds;
              thisGame.HomeSpecial = mappedArr[0].HomeSpecial;
              thisGame.HomeSpecialOdds = mappedArr[0].HomeSpecialOdds;
            }

            let gamesCop = games;
            Promise.resolve().then(() => {
              setGames(gamesCop);
              setLastChangedGamedID(idGame);
              setIsLoading(false);
            });
          }
        });
    } else {
      if (1 > 0) {
        Promise.all([
          getGameTypes(),
          getGameColors(),
          axios({
            method: "post",
            url: process.env.REACT_APP_API2_URL + "/Game/Games_GetSchedule",
            /*  REPLACE WITH SELECT DATA */
            data: {
              Idsport: IdSport,
              Idlinetype: lineTypeID,
              Idleague: leagueID,
              Action: lineTypeAction,
              OrderType: 2,
              DisplayPeriod: "A",
              MoveClaseGames: 0,
              IdUser: userInfo.userId,
            },
          }).then((response) => response.data),
        ]).catch((error) => {
          console.error("Games_GetSchedule Promise.all failed:", error);
          setIsLoading(false);
        }).then((results) => {
          if (!results) return;
          const [gameGameTypes, gameColors, data] = results;
let mappedArr = (data || []).map((x) => {
            const gc = gameColors.find((c) => (c.gameStat ?? c.GameStat) === x.gameStat);
            const gt = gameGameTypes.find((t) => (t.idGameType ?? t.IdGameType) === x.idGameType);
            return {
            ...x,
            gameColor: gc,
            gameType: gt,
            GameColor: gc,
            GameType: gt,
            VisitorSpread: IdSport !== "NHL" ? x.visitorSpread : x.visitorSpecial,
            VisitorSpreadOdds: IdSport !== "NHL" ? x.visitorSpreadOdds : x.visitorSpecialOdds,
            HomeSpread: IdSport !== "NHL" ? x.homeSpread : x.homeSpecial,
            HomeSpreadOdds: IdSport !== "NHL" ? x.homeSpreadOdds : x.homeSpecialOdds,
            };
          });
          if (open == true) {
            mappedArr = mappedArr.filter(
              (g) => g.gameStat == "O" || g.gameStat == "B"
            );
          }
          setGames(mappedArr);
          setLastChangedGamedID(idGame);
          setIsLoading(false);
        });
      }
    }
  };

  const setLastChangedGamedID = (idgame) => {
    setRecentUpdatedGame(idgame);
  };
  useEffect(() => {
    //Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/LineType/GetLineTypes";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setLineTypes(data);
      });
  }, [setLineTypes]);

  const filterGames = (e) => {
    setFilterStr(e.target.value);
  };

  useEffect(() => {
    //Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/League/GetAllSports";
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let groupingInfo = data.map((v) => ({ ...v, idSport: v.idSport?.trim() }));
        if (groupingInfo.length > 0) {
          setIdSport(groupingInfo[0].idSport);
          setSportChange(false);
          setSportChange(true);
          GetLeagues(groupingInfo[0].idSport);
          setLeagueID(-1)
        }
        setSports(groupingInfo);
      }).catch((error) => console.error("GetAllSports failed:", error));
  }, []);

  const GetLeagues = (idSport) => {
    //Change for server api address
    const url =
      process.env.REACT_APP_API2_URL +
      "/League/League_GetLeaguesByIdSport?idSport=" +
      idSport;
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let leagueInfo = data.map((v) => ({ ...v, idLineType: v.idLeague }));
        leagueInfo.unshift({ idLineType: -1, description: "All" });
        const sortedData = leagueInfo.sort((a, b) => {
          if (a.leagueOrder !== b.leagueOrder) {
            return a.leagueOrder - b.leagueOrder;
          }
          return (a.description || "").localeCompare(b.description || "");
        });
        setLeagues(sortedData);
        setLeagueID(-1);
      });
  };

  useEffect(() => {
    IdSport && lineTypeID && searchGameValues();
  }, [IdSport]);
  useEffect(() => {
    //IdSport && lineTypeID && setEventKey();
    IdSport && lineTypeID && searchGameValues();
  }, [lineTypeID]);
  useEffect(() => {
    //IdSport && lineTypeID && setEventKey();
    IdSport && lineTypeID && lineTypeAction && searchGameValues();
  }, [lineTypeAction]);

  useEffect(() => {
    IdSport && searchGameValues();
  }, [setGames]);

  /** */
  function changeSportID(value) {
    setLeagueID(-1);
    setIdSport(value);
    ClearArrar();
    setSportChange(false);
    setSportChange(true);
    GetLeagues(value);
  }

  function changeLineTypeID(value) {
    let linetype = {};
    linetype.value = value;
    setlineTypeID(value);
    ClearArrar();
    setSportChange(false);
    setSportChange(true);
  }
  function changeLeagueID(value) {
    //setGames([]);
    setLeagueID(value);
    setSportChange(false);
    setSportChange(true);
  }

  const handleChangeAction = () => {
    if (!action) {
      setAction(!action);
      setLineTypeAction(-1);
    } else {
      setAction(!action);
      setLineTypeAction(lineTypeID["value"]);
    }
  };

  const ClearArrar = () => {
    setSelectedGame([]);
    setFamilyGameFilter(null);
  };

  const handleClickCheck = (
    name,

    visitorOdds
  ) => {
    let newSelected = [];
    if (IdSport.trim() !== "TNT") {
      const selectedIndex = selectedGame.indexOf(name);
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selectedGame, name);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selectedGame.slice(1));
      } else if (selectedIndex === selectedGame.length - 1) {
        newSelected = newSelected.concat(selectedGame.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selectedGame.slice(0, selectedIndex),
          selectedGame.slice(selectedIndex + 1)
        );
      }
    } else {
      const selectedIndex = selectedGame.indexOf(visitorOdds);
      if (selectedIndex === -1) {
        setIdGameTNT(name);
        newSelected = newSelected.concat(selectedGame, visitorOdds);
      } else if (selectedIndex === 0) {
        setIdGameTNT(name);
        newSelected = newSelected.concat(selectedGame.slice(1));
      } else if (selectedIndex === selectedGame.length - 1) {
        setIdGameTNT(name);
        newSelected = newSelected.concat(selectedGame.slice(0, -1));
      } else if (selectedIndex > 0) {
        setIdGameTNT(0);
        newSelected = newSelected.concat(
          selectedGame.slice(0, selectedIndex),
          selectedGame.slice(selectedIndex + 1)
        );
      }
    }
    console.log(newSelected)
    setSelectedGame(newSelected);
  };

  return (
    <Paper className={classes.root} style={{ position: "relative" }}>
      {isGrading && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
          <div style={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: "32px 48px",
            textAlign: "center",
            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            maxWidth: "480px",
          }}>
            <div style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "8px" }}>
              Grading in progress
            </div>
            <div style={{ fontSize: "13px", color: "#555" }}>
              Grading process initiated, please wait. Do not press Ctrl + G while the process is running.
            </div>
          </div>
        </div>
      )}
      <KeyboardEventHandler
        handleKeys={["function", "ctrl+f9", "ctrl+f10", "ctrl+f11", "ctrl+f12", "ctrl+g"]}
        onKeyEvent={(key, e) => setEventKey(key, e)}
      />

      <div className="flex flex-col items-center w-full gap-3 p-4 mb-3 bg-white shadow-sm border border-gray-100 rounded-2xl lg:flex-row">
        {SportChange === true ? (
          <InputSelect
            size="small"
            classes="w-full lg:w-auto lg:flex-1"
            label="Sports"
            variant="outlined"
            name="name"
            data={sports}
            placeholder="Sports"
            setSelectValue={changeSportID}
            startValue={IdSport}
          />
        ) : (
          ""
        )}{" "}
        <InputSelect
          size="small"
          classes="w-full lg:w-auto lg:flex-1"
          label="Line Types"
          variant="outlined"
          name="name"
          data={lineTypes}
          placeholder="LineTypes"
          setSelectValue={changeLineTypeID}
          startValue={lineTypeID}
        />
        <DelayInput
          size="small"
          className="custom-input"
          element={TextField}
          label="Filter"
          minLength={1}
          delayTimeout={500}
          value=""
          variant="outlined"
          placeholder="Filter By Team Name or Rotation Number"
          onChange={filterGames}
        />
        <InputSelect
          size="small"
          classes="w-full lg:w-auto lg:flex-1"
          label="Leagues"
          variant="outlined"
          name="name"
          data={leagues}
          placeholder="Leagues"
          setSelectValue={changeLeagueID}
          startValue={leagueID}
        />
        <Button
          className="w-full lg:w-auto lg:flex-1"
          variant="contained"
          color="primary"
          disableElevation
          style={{ borderRadius: 8, fontWeight: 600, textTransform: "none" }}
          onClick={searchGameValues}
        >
          Search
        </Button>
      </div>
      <div className="flex flex-row pb-2">
        <div className="flex items-center w-max gap-4 px-4 py-1.5 bg-white border border-gray-200 rounded-full text-sm text-gray-600">
          <label className="flex items-center gap-1.5 cursor-pointer">
            <Switch
              checked={open}
              onChange={(ev) => setOpen(ev.currentTarget.checked)}
              disableRipple
              classes={{
                root: classes.switchRoot,
                switchBase: classes.switchBase,
                thumb: classes.switchThumb,
                track: classes.switchTrack,
                checked: classes.switchChecked,
              }}
            />
            Open Games Only
          </label>
          <div className="w-px h-4 bg-gray-200" />
          <label className="flex items-center gap-1.5 cursor-pointer">
            <Switch
              checked={action}
              onChange={handleChangeAction}
              disableRipple
              classes={{
                root: classes.switchRoot,
                switchBase: classes.switchBase,
                thumb: classes.switchThumb,
                track: classes.switchTrack,
                checked: classes.switchChecked,
              }}
            />
            Action
          </label>
        </div>
      </div>

      <Table>
        <TableRow>
          <TableCell></TableCell>
          <TableCell style={{ width: "20%" }}>
            {isLoading ? <Loader height={80} width={80}></Loader> : ""}
          </TableCell>
        </TableRow>
      </Table>
      {IdSport.trim() !== "TNT" ? (
        <Schedule
          IdLinetype={lineTypeID}
          IdSport={IdSport}
          data={familyGameFilter ? games?.filter((g) => g.parentGame === familyGameFilter) : games}
          userId={userInfo.userId}
          //announce={props.announce}
          filterStr={filterStr}
          getRecentGame={props.getRecentGame}
          searchGameValues={searchGameValues}
          setLastChangedGamedID={setLastChangedGamedID}
          lastChangedGamedID={recentUpdatedGame}
          isChanged={isChanged}
          selectedGame={selectedGame}
          handleClickCheck={handleClickCheck}
          ClearArrar={ClearArrar}
          IdGameTNT={idGameTNT}
          setIsLoading={setIsLoading}
          setSelectedGame={setSelectedGame}
        ></Schedule>
      ) : (
        <ScheduleTNT
          IdLinetype={lineTypeID}
          IdSport={IdSport.trim()}
          data={familyGameFilter ? games?.filter((g) => g.parentGame === familyGameFilter) : games}
          userId={userInfo.userId}
          //announce={props.announce}
          filterStr={filterStr}
          getRecentGame={props.getRecentGame}
          searchGameValues={searchGameValues}
          setLastChangedGamedID={setLastChangedGamedID}
          lastChangedGamedID={recentUpdatedGame}
          isChanged={isChanged}
          selectedGame={selectedGame}
          handleClickCheck={handleClickCheck}
          ClearArrar={ClearArrar}
          IdGameTNT={idGameTNT}
          setIsLoading={setIsLoading}
        ></ScheduleTNT>
      )}
    </Paper>
  );
});

export default LinesManager;
